import { Service } from './service.interface';

export const initialState: Service = {
  contact: {
    saving: false,
    saveSuccess: false,
  },
};
